import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormGroup, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ISelectedVoteOption } from '../../../models/ballot-base/proxy-vote/selected-vote-option';
import { IVoteOption } from '../../../../../../shared/models/ballot-vote';


@Component({
    selector: 'app-vote-option-card',
    templateUrl: './vote-option-card.component.html',
    styleUrl: './vote-option-card.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VoteOptionCardComponent),
            multi: true,
        }
    ],
    standalone: false
})

export class VoteOptionCardComponent<TVoteOptionId> implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() voteOptionId: TVoteOptionId | null | undefined = null;
  @Input() id: string = 'vote-option' + this.voteOptionId;
  @Input() voteOptions: { [key: string]: IVoteOption } = {};

  isDisabled: boolean = false;
  subscriptions: Subscription = new Subscription();

  voteOptionForm: FormGroup = new FormGroup({
    chkVoteOptionCtrl: new FormControl(false),
    commentCtrl: new FormControl(''),
  });

  get chkVoteOptionCtrl() : FormControl {
    return this.voteOptionForm.get('chkVoteOptionCtrl') as FormControl
  }

  get commentCtrl() : FormControl {
    return this.voteOptionForm.get('commentCtrl') as FormControl
  }

  onChange: (value: ISelectedVoteOption<TVoteOptionId>) => void = () => {};
  onTouched: any = () => { };

  voteOptionClass: IVoteOption = this.voteOptions[this.voteOptionId as unknown as string] || {};

  ngOnInit(): void {
    this.voteOptionClass = this.voteOptions[this.voteOptionId as unknown as string] || {};
    this.setupFormSubscription();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  writeValue(newValue: Partial<ISelectedVoteOption<TVoteOptionId>>): void {
    if (!newValue) {
      return;
    }

    if (Object.hasOwn(newValue, 'isChecked')) {
      this.chkVoteOptionCtrl.patchValue(newValue.isChecked ?? false, {emitEvent: false});
    }

    if (Object.hasOwn(newValue, 'comment')) {
      this.commentCtrl.patchValue(newValue.comment ?? '', {emitEvent: false});
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  setupFormSubscription() {
    this.subscriptions.add(
      this.voteOptionForm.valueChanges.subscribe((formValue: Partial<IVoteOptionData>) => {
        const newValue : ISelectedVoteOption<TVoteOptionId> = {
          voteOptionId: this.voteOptionId as TVoteOptionId,
          isChecked: formValue.chkVoteOptionCtrl? formValue.chkVoteOptionCtrl : false,
          comment: formValue.commentCtrl ? formValue.commentCtrl : null,
        };

        this.onChange(newValue);
      })
    );
  }
}

interface IVoteOptionData {
  chkVoteOptionCtrl: boolean;
  commentCtrl: string;
}
